import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute Component
 * Wrapper component that protects routes requiring authentication
 * Redirects to login page if user is not authenticated
 * 
 * @param {React.Component} children - Child components to render if authenticated
 * @returns {React.Component} Children or Navigate to login
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Dok se auth stanje utvrđuje (provera tokena / tihi refresh) NE prikazujemo
  // pun ekran "Učitavanje...". Umesto toga renderujemo `children` (Shell), pa
  // glavni meni (levi sidebar) i header ostaju vidljivi. Sam Shell sakriva
  // sadržaj stranice dok se auth ne razreši (vidi Shell.js -> authLoading),
  // tako da se stranice neće renderovati niti pozivati API bez tokena.
  if (loading) {
    return children;
  }

  // Redirect to login if not authenticated
  // Preserve the location they were trying to access
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // User is authenticated, render children
  return children;
};

export default ProtectedRoute;
